webpackJsonp([8],{

/***/ "3b3G":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("yGwj")(false);
// Module
exports.push([module.i, "\n.fade-enter-active[data-v-7ba5bd90],\n.fade-leave-active[data-v-7ba5bd90] {\n  -webkit-transition-property: opacity;\n  transition-property: opacity;\n  -webkit-transition-duration: 0.25s;\n          transition-duration: 0.25s;\n}\n.fade-enter-active[data-v-7ba5bd90] {\n  -webkit-transition-delay: 0.25s;\n          transition-delay: 0.25s;\n}\n.fade-enter[data-v-7ba5bd90],\n.fade-leave-active[data-v-7ba5bd90] {\n  opacity: 0;\n}\n", ""]);


/***/ }),

/***/ "4ZlO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* eslint-disable import/prefer-default-export */


/**
 * for functional approach, we have this abstraction
 * - const myObject = { data: [...], anotherKey: ... }
 * - const dataValue = getData(myObject) // instead of : const dataValue = myObject.data
 * We do this to make more easy to read and maintain a code
 * In addition, the code that goes to the browser can be more optimized and smaller
 *
 * Abstractions are powerful things, with small modifications this function can be more efficient
 * - const getData = (obj, defaultValue) => get(obj, 'data', defaultValue)
 * seet https://lodash.com/docs#get for more details
 */
var getData = function getData(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(obj, 'data');
};

/***/ }),

/***/ "7K8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__("QmSG");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./src/plugins/http/interceptors.js

/* harmony default export */ var interceptors = (function (http, store, router) {

  http.interceptors.request.use(function (config) {
    store.dispatch('setLoading', true);
    return config;
  }, function (error) {
    store.dispatch('setLoading', false);
    return promise_default.a.reject(error);
  });

  http.interceptors.response.use(function (response) {
    store.dispatch('setLoading', false);
    return response;
  }, function (error) {
    var response = error.response;


    if (!error.response) {
      store.dispatch('setLoading', false);
      store.dispatch('showMessage', {
        type: 'danger',
        content: 'Ocorreu um erro interno no servidor. Tente novamente.'
      });
      return promise_default.a.reject(error);
    }

    /**
     * If token is either expired, not provided or invalid
     * then redirect to login.
     */
    if (401 === response.status) {
      store.dispatch('showMessage', {
        type: 'danger',
        content: 'A sessão expirou. Efetue o login novamente.'
      });

      store.dispatch('auth/logout');

      router.push({
        name: 'auth.login'
      });
    }

    /**
     * Show error messages
     */
    if (response.data.message) {
      store.dispatch('showMessage', {
        type: 'danger',
        content: response.data.message
      });
    }

    store.dispatch('setLoading', false);

    return promise_default.a.reject(error);
  });
});
// CONCATENATED MODULE: ./src/plugins/http/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return http_http; });
/* harmony export (immutable) */ __webpack_exports__["a"] = install;




// allow use http client without Vue instance
var http_http = axios_default.a.create({
    baseURL: config["a" /* apiUrl */],
    withCredentials: true
});

// receive store and data by options
// https://vuejs.org/v2/guide/plugins.html
function install(Vue, _ref) {
    var store = _ref.store,
        router = _ref.router;

    interceptors(http_http, store, router);
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
    Object.defineProperty(Vue.prototype, '$http', {
        get: function get() {
            return http_http;
        }
    });
}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/pure-css-loader/dist/css-loader.css
var css_loader = __webpack_require__("SMGD");
var css_loader_default = /*#__PURE__*/__webpack_require__.n(css_loader);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Loading.vue
//
//
//
//
//



/* harmony default export */ var Loading = ({
  name: "Loading",
  props: {
    show: {
      required: true,
      type: Boolean
    },
    text: {
      type: String
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efe9d588","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    directives: [
      { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
    ],
    staticClass: "loader loader-default is-active",
    attrs: { "data-text": _vm.text, "data-blink": "" }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Loading = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-efe9d588", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/Loading.vue
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Loading,
  components_Loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Loading.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-efe9d588", Component.options)
  } else {
    hotAPI.reload("data-v-efe9d588", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var src_components_Loading = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var App = ({
  name: "EvasaoApp",
  components: {
    Loading: src_components_Loading
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(["clearMessages"])),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["loading"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_c("router-view", { key: _vm.$route.fullPath })],
        1
      ),
      _vm._v(" "),
      _c("loading", {
        attrs: { show: _vm.loading, text: "Por favor, aguarde..." }
      })
    ],
    1
  )
}
var App_staticRenderFns = []
App_render._withStripped = true
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", App_esExports)
  }
}
// CONCATENATED MODULE: ./src/App.vue
var App_disposed = false
function injectStyle (ssrContext) {
  if (App_disposed) return
  __webpack_require__("p9lV")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = injectStyle
/* scopeId */
var App___vue_scopeId__ = "data-v-7ba5bd90"
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)
App_Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", App_Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", App_Component.options)
  }
  module.hot.dispose(function (data) {
    App_disposed = true
  })
})()}

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations-type.js
var SET_LOADING = 'SET_LOADING';
var SET_MESSAGE = 'SET_MESSAGE';
// CONCATENATED MODULE: ./src/store/mutations.js


var _types$SET_LOADING$ty;



// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.

/* harmony default export */ var mutations = (_types$SET_LOADING$ty = {}, defineProperty_default()(_types$SET_LOADING$ty, SET_LOADING, function (state, loading) {
  state.loading = loading;
}), defineProperty_default()(_types$SET_LOADING$ty, SET_MESSAGE, function (state, message) {
  state.message = message;
}), _types$SET_LOADING$ty);
// CONCATENATED MODULE: ./src/store/actions.js


// actions are functions that cause side effects and can involve
// asynchronous operations.

/* harmony default export */ var actions = ({
  showMessage: function showMessage(_ref, content) {
    var commit = _ref.commit;

    commit(SET_MESSAGE, content);
  },
  setLoading: function setLoading(_ref2, loading) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit(SET_LOADING, loading);
    dispatch('clearMessages');
  },
  clearMessages: function clearMessages(_ref3) {
    var commit = _ref3.commit;

    commit(SET_MESSAGE, "");
  }
});
// CONCATENATED MODULE: ./src/store/getters.js
/* harmony default export */ var store_getters = ({
  message: function message(state) {
    return state.message;
  },
  loading: function loading(state) {
    return state.loading;
  }
});
// CONCATENATED MODULE: ./src/store/state.js
/* harmony default export */ var store_state = ({
  loading: false,
  message: {
    type: null,
    content: null
  }
});
// CONCATENATED MODULE: ./src/pages/auth/store/state.js
/* harmony default export */ var auth_store_state = ({
  user: {}
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/localforage/dist/localforage.js
var localforage = __webpack_require__("22C0");
var localforage_default = /*#__PURE__*/__webpack_require__.n(localforage);

// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__("QmSG");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./src/pages/auth/store/mutations-types.js
var SET_USER = 'SET_USER';
// EXTERNAL MODULE: ./src/plugins/http/index.js + 1 modules
var http = __webpack_require__("7K8a");

// EXTERNAL MODULE: ./src/util/get.js
var get = __webpack_require__("4ZlO");

// CONCATENATED MODULE: ./src/pages/auth/api/index.js



var api_postLogin = function postLogin(_ref) {
    var code = _ref.code;
    return http["b" /* http */].post('/auth/login', { code: code }).then(get["a" /* getData */]);
};

var api_logoutApp = function logoutApp() {
    return http["b" /* http */].get('/auth/logout').then(get["a" /* getData */]);
};

var api_loadUserData = function loadUserData() {
    return http["b" /* http */].get('/auth/me').then(get["a" /* getData */]);
};

/* harmony default export */ var api = ({
    postLogin: api_postLogin,
    logoutApp: api_logoutApp,
    loadUserData: api_loadUserData
});
// CONCATENATED MODULE: ./src/pages/auth/store/actions.js


// src is a alias. see client/build/webpack.base.conf.js





var actions_attemptLogin = function attemptLogin(_ref, payload) {
  var dispatch = _ref.dispatch;
  return api.postLogin(payload).then(function (user) {
    dispatch('setUser', user);
    return user; // keep promise chain
  });
};

var actions_checkUser = function checkUser(_ref2) {
  var dispatch = _ref2.dispatch,
      state = _ref2.state;

  if (!Object(lodash["isEmpty"])(state.user)) {
    return promise_default.a.resolve(state.user);
  }
  dispatch('loadUser');
};

var actions_logout = function logout(_ref3) {
  var dispatch = _ref3.dispatch;

  api.logoutApp().then(function (response) {
    window.location = response.url_logout;
  });
  // call actions
  return promise_default.a.all([dispatch('setUser', {})]);
};

var actions_setUser = function setUser(_ref4, user) {
  var commit = _ref4.commit;

  // Commit the mutations
  commit(SET_USER, user);

  var userId = user.id || '';

  localforage_default.a.setItem(config["h" /* userIdStorageKey */], userId);

  promise_default.a.resolve(user); // keep promise chain
};

var actions_loadUser = function loadUser(_ref5) {
  var dispatch = _ref5.dispatch;
  return api.loadUserData()
  // store user's data
  .then(function (user) {
    return dispatch('setUser', user);
  }).catch(function () {
    // Process failure, delete the token
    return promise_default.a.reject('FAIL_IN_LOAD_USER'); // keep promise chain
  });
};

/* harmony default export */ var store_actions = ({
  checkUser: actions_checkUser,
  attemptLogin: actions_attemptLogin,
  logout: actions_logout,
  setUser: actions_setUser,
  loadUser: actions_loadUser
});
// CONCATENATED MODULE: ./src/pages/auth/store/mutations.js

// https://vuex.vuejs.org/en/mutations.html


/* eslint-disable no-param-reassign */
/* harmony default export */ var store_mutations = (defineProperty_default()({}, SET_USER, function (state, value) {
  state.user = value;
}));
// CONCATENATED MODULE: ./src/pages/auth/store/getters.js
// http://vuex.vuejs.org/en/getters.html


// if has token, we assume that user is logged in our system
var getters_isLogged = function isLogged(_ref) {
  var user = _ref.user;
  return !Object(lodash["isEmpty"])(user);
};

// get current user data
var currentUser = function currentUser(_ref2) {
  var user = _ref2.user;
  return user;
};

/* harmony default export */ var auth_store_getters = ({
  isLogged: getters_isLogged,
  currentUser: currentUser
});
// CONCATENATED MODULE: ./src/pages/auth/store/index.js





/* harmony default export */ var store = ({
  namespaced: true,
  state: auth_store_state,
  actions: store_actions,
  mutations: store_mutations,
  getters: auth_store_getters
});
// CONCATENATED MODULE: ./src/pages/dashboard/store/state.js
/* harmony default export */ var dashboard_store_state = ({});
// CONCATENATED MODULE: ./src/pages/dashboard/store/actions.js
/* harmony default export */ var dashboard_store_actions = ({});
// CONCATENATED MODULE: ./src/pages/dashboard/store/mutations.js
/* harmony default export */ var dashboard_store_mutations = ({});
// CONCATENATED MODULE: ./src/pages/dashboard/store/getters.js
/* harmony default export */ var dashboard_store_getters = ({});
// CONCATENATED MODULE: ./src/pages/dashboard/store/index.js





/* harmony default export */ var dashboard_store = ({
  namespaced: true,
  state: dashboard_store_state,
  actions: dashboard_store_actions,
  mutations: dashboard_store_mutations,
  getters: dashboard_store_getters
});
// CONCATENATED MODULE: ./src/pages/estudantes/store/state.js
/* harmony default export */ var estudantes_store_state = ({
  estudante: null,
  estudanteSimulacao: null,
  estudantes: [],
  paginacao: {},
  formSimulacao: {},
  variaveisSimulacao: [],
  variaveisImportancia: [],
  variaveisInformacoes: [],
  modelo: null,
  ordenacaoBusca: {
    campo: 'nome_aluno',
    ordem: 1
  },
  formBusca: {
    unidade: null,
    unidades: [],
    modalidade: null,
    modalidades: [],
    curso: null,
    cursos: [],
    versao: null,
    versoes: [],
    turma: null,
    turmas: [],
    nome: "",
    pagina: 1,
    faixa_evasao: [0, 100]
  }
});
// EXTERNAL MODULE: ./src/pages/estudantes/api/index.js
var estudantes_api = __webpack_require__("fhp6");

// CONCATENATED MODULE: ./src/pages/estudantes/store/mutations-types.js
var SET_ESTUDANTE = 'SET_ESTUDANTE';
var SET_ESTUDANTES = 'SET_ESTUDANTES';
var SET_ORDENACAO_BUSCA = 'SET_ORDENACAO_BUSCA';
var SET_PAGINACAO = 'SET_PAGINACAO';
var SET_UNIDADES = 'SET_UNIDADES';
var SET_MODALIDADES = 'SET_MODALIDADES';
var SET_CURSOS = 'SET_CURSOS';
var SET_VERSOES = 'SET_VERSOES';
var SET_TURMAS = 'SET_TURMAS';
var SET_VARIAVEIS_SIMULACAO = 'SET_VARIAVEIS_SIMULACAO';
var SET_VARIAVEIS_IMPORTANCIA = 'SET_VARIAVEIS_IMPORTANCIA';
var SET_VARIAVEIS_INFORMACOES = 'SET_VARIAVEIS_INFORMACOES';
var SET_ESTUDANTE_SIMULACAO = 'SET_ESTUDANTE_SIMULACAO';
var SET_FORM_SIMULACAO = 'SET_FORM_SIMULACAO';
var SET_MODELO = 'SET_MODELO';
// CONCATENATED MODULE: ./src/pages/estudantes/store/actions.js



var actions_fetchEstudantes = function fetchEstudantes(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch,
      getters = _ref.getters;

  commit(SET_ESTUDANTES, []);
  estudantes_api["a" /* default */].fetchEstudantes({
    unidade: getters.formBusca.unidade ? getters.formBusca.unidade.nome : "",
    modalidade: getters.formBusca.modalidade ? getters.formBusca.modalidade.nome : "",
    curso: getters.formBusca.curso ? getters.formBusca.curso.nome : "",
    versao: getters.formBusca.versao ? getters.formBusca.versao.nome : "",
    turma: getters.formBusca.turma ? getters.formBusca.turma.nome : "",
    nome: getters.formBusca.nome,
    pagina: getters.formBusca.pagina,
    campo_ordem: getters.ordenacaoBusca.campo,
    ordem: getters.ordenacaoBusca.ordem,
    min_evasao: getters.formBusca.faixa_evasao[0],
    max_evasao: getters.formBusca.faixa_evasao[1]
  }).then(function (response) {
    commit(SET_ESTUDANTES, response.estudantes);
    commit(SET_PAGINACAO, response.paginacao);
    if (!response.estudantes.length) {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi encontrado nenhum estudante"
      }, {
        root: true
      });
    }
  }).catch(function (error) {
    dispatch('showMessage', {
      type: "danger",
      content: "Não foi possível buscar os estudantes"
    }, {
      root: true
    });
  });
};

var actions_fetchEstudante = function fetchEstudante(_ref2, id_matricula) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  commit(SET_ESTUDANTE, null);
  estudantes_api["a" /* default */].fetchEstudante(id_matricula).then(function (response) {
    commit(SET_ESTUDANTE, response.estudante);
    if (!response.estudante) {
      dispatch('showMessage', {
        type: "danger",
        content: "Estudante não existente"
      }, {
        root: true
      });
    }
  }).catch(function (error) {
    dispatch('showMessage', {
      type: "danger",
      content: "Não foi possível localizar o estudante"
    }, {
      root: true
    });
  });
};

var actions_fetchUnidades = function fetchUnidades(_ref3) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  commit(SET_UNIDADES, []);
  estudantes_api["a" /* default */].fetchUnidades().then(function (response) {
    commit(SET_UNIDADES, response.unidades);
    if (!response.unidades.length) {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi encontrado nenhuma unidade com alunos regulares"
      }, {
        root: true
      });
    }
  }).catch(function (error) {
    dispatch('showMessage', {
      type: "danger",
      content: "Não foi possível buscar as unidades"
    }, {
      root: true
    });
  });
};

var actions_fetchModalidades = function fetchModalidades(_ref4, params) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  commit(SET_MODALIDADES, []);
  estudantes_api["a" /* default */].fetchModalidades(params).then(function (response) {
    commit(SET_MODALIDADES, response.modalidades);
    if (!response.modalidades.length) {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi encontrado nenhuma modalidade com alunos regulares"
      }, {
        root: true
      });
    }
  }).catch(function (error) {
    dispatch('showMessage', {
      type: "danger",
      content: "Não foi possível realizar a busca de modalidades"
    }, {
      root: true
    });
  });
};

var actions_fetchCursos = function fetchCursos(_ref5, params) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  commit(SET_CURSOS, []);
  estudantes_api["a" /* default */].fetchCursos(params).then(function (response) {
    commit(SET_CURSOS, response.cursos);
    if (!response.cursos.length) {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi encontrado nenhum curso com alunos regulares"
      }, {
        root: true
      });
    }
  }).catch(function (error) {
    dispatch('showMessage', {
      type: "danger",
      content: "Não foi possível realizar a busca de cursos"
    }, {
      root: true
    });
  });
};

var actions_fetchTurmas = function fetchTurmas(_ref6, params) {
  var commit = _ref6.commit,
      dispatch = _ref6.dispatch;

  commit(SET_TURMAS, []);
  estudantes_api["a" /* default */].fetchTurmas(params).then(function (response) {
    commit(SET_TURMAS, response.turmas);
    if (!response.turmas.length) {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi encontrado nenhuma turma"
      }, {
        root: true
      });
    }
  }).catch(function (error) {
    dispatch('showMessage', {
      type: "danger",
      content: "Não foi possível realizar a busca de turmas"
    }, {
      root: true
    });
  });
};

var actions_fetchVersoes = function fetchVersoes(_ref7, params) {
  var commit = _ref7.commit,
      getters = _ref7.getters,
      dispatch = _ref7.dispatch;

  var versoes = [];
  commit(SET_VERSOES, versoes);
  var cursoSelecionado = getters.formBusca.cursos.find(function (curso) {
    return curso.nome == params.curso;
  });

  if (cursoSelecionado) {
    cursoSelecionado.versoes.forEach(function (versao) {
      versoes.push({
        'nome': String(versao)
      });
    });
    commit(SET_VERSOES, versoes);
  }
};

var actions_fetchVariaveisSimulacao = function fetchVariaveisSimulacao(_ref8) {
  var commit = _ref8.commit,
      dispatch = _ref8.dispatch,
      getters = _ref8.getters;

  commit(SET_VARIAVEIS_SIMULACAO, []);
  commit(SET_FORM_SIMULACAO, {});
  estudantes_api["a" /* default */].fetchVariaveisSimulacao().then(function (response) {

    var variaveis = response.variaveis;
    commit(SET_VARIAVEIS_SIMULACAO, variaveis);

    var formSimulacao = {};
    variaveis.forEach(function (variavel) {
      formSimulacao[variavel.nome] = getters.estudante[variavel.nome];
    });
    commit(SET_FORM_SIMULACAO, formSimulacao);

    if (!response.variaveis.length) {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi encontrado nenhuma variável para simulação"
      }, {
        root: true
      });
    }
  }).catch(function (error) {
    dispatch('showMessage', {
      type: "danger",
      content: "Ocorreu um erro ao carregar as variáveis para simulação"
    }, {
      root: true
    });
  });
};

var actions_fetchSimulacao = function fetchSimulacao(_ref9, params) {
  var commit = _ref9.commit,
      dispatch = _ref9.dispatch,
      getters = _ref9.getters;

  var id_matricula = getters.estudante.id_matricula;
  commit(SET_ESTUDANTE_SIMULACAO, null);
  estudantes_api["a" /* default */].fetchSimulacao(id_matricula, params).then(function (response) {
    commit(SET_ESTUDANTE_SIMULACAO, response.estudante);
    if (!response.estudante) {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi encontrado os dados do estudante para simulação"
      }, {
        root: true
      });
    }
  }).catch(function (error) {
    dispatch('showMessage', {
      type: "danger",
      content: "Ocorreu um erro ao gerar a simulação"
    }, {
      root: true
    });
  });
};

var actions_fetchVariaveisImportancia = function fetchVariaveisImportancia(_ref10) {
  var commit = _ref10.commit,
      dispatch = _ref10.dispatch,
      getters = _ref10.getters;

  var id_matricula = getters.estudante.id_matricula;
  commit(SET_VARIAVEIS_IMPORTANCIA, []);
  estudantes_api["a" /* default */].fetchVariaveisImportancia(id_matricula).then(function (response) {
    commit(SET_VARIAVEIS_IMPORTANCIA, response.variaveis);
  }).catch(function (error) {
    dispatch('showMessage', {
      type: "danger",
      content: "Ocorreu um erro ao carregar a importância das variáveis do estudante"
    }, {
      root: true
    });
  });
};

var actions_fetchVariaveisAbaInformacoes = function fetchVariaveisAbaInformacoes(_ref11) {
  var commit = _ref11.commit,
      dispatch = _ref11.dispatch,
      getters = _ref11.getters;

  var id_matricula = getters.estudante.id_matricula;
  commit(SET_VARIAVEIS_INFORMACOES, []);
  estudantes_api["a" /* default */].fetchVariaveisAbaInformacoes(id_matricula).then(function (response) {
    commit(SET_VARIAVEIS_INFORMACOES, response.variaveis);
    if (!response.variaveis.length) {
      dispatch('showMessage', {
        type: "danger",
        content: "Não foi encontrado as variáveis com as informações do estudante"
      }, {
        root: true
      });
    }
  }).catch(function (error) {
    dispatch('showMessage', {
      type: "danger",
      content: "Ocorreu um erro ao carregar as variáveis com as informações do estudante"
    }, {
      root: true
    });
  });
};

/* harmony default export */ var estudantes_store_actions = ({
  fetchEstudantes: actions_fetchEstudantes,
  fetchEstudante: actions_fetchEstudante,
  fetchUnidades: actions_fetchUnidades,
  fetchModalidades: actions_fetchModalidades,
  fetchCursos: actions_fetchCursos,
  fetchTurmas: actions_fetchTurmas,
  fetchVersoes: actions_fetchVersoes,
  fetchVariaveisSimulacao: actions_fetchVariaveisSimulacao,
  fetchSimulacao: actions_fetchSimulacao,
  fetchVariaveisImportancia: actions_fetchVariaveisImportancia,
  fetchVariaveisAbaInformacoes: actions_fetchVariaveisAbaInformacoes
});
// CONCATENATED MODULE: ./src/pages/estudantes/store/mutations.js


var _types$SET_ESTUDANTE$;



/* harmony default export */ var estudantes_store_mutations = (_types$SET_ESTUDANTE$ = {}, defineProperty_default()(_types$SET_ESTUDANTE$, SET_ESTUDANTE, function (state, estudante) {
  state.estudante = estudante;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_ESTUDANTES, function (state, estudantes) {
  state.estudantes = estudantes;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_PAGINACAO, function (state, paginacao) {
  state.paginacao = paginacao;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_ORDENACAO_BUSCA, function (state, ordenacaoBusca) {
  state.ordenacaoBusca = ordenacaoBusca;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_UNIDADES, function (state, unidades) {
  state.formBusca.unidades = unidades;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_MODALIDADES, function (state, modalidades) {
  state.formBusca.modalidades = modalidades;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_CURSOS, function (state, cursos) {
  state.formBusca.cursos = cursos;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_TURMAS, function (state, turmas) {
  state.formBusca.turmas = turmas;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_VERSOES, function (state, versoes) {
  state.formBusca.versoes = versoes;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_VARIAVEIS_SIMULACAO, function (state, variaveis) {
  state.variaveisSimulacao = variaveis;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_ESTUDANTE_SIMULACAO, function (state, estudante) {
  state.estudanteSimulacao = estudante;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_VARIAVEIS_IMPORTANCIA, function (state, variaveis) {
  state.variaveisImportancia = variaveis;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_FORM_SIMULACAO, function (state, form) {
  state.formSimulacao = form;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_VARIAVEIS_INFORMACOES, function (state, variaveis) {
  state.variaveisInformacoes = variaveis;
}), defineProperty_default()(_types$SET_ESTUDANTE$, SET_MODELO, function (state, modelo) {
  state.modelo = modelo;
}), _types$SET_ESTUDANTE$);
// CONCATENATED MODULE: ./src/pages/estudantes/store/getters.js
/* harmony default export */ var estudantes_store_getters = ({
  estudantes: function estudantes(state) {
    return state.estudantes;
  },
  estudante: function estudante(state) {
    return state.estudante;
  },
  paginacao: function paginacao(state) {
    return state.paginacao;
  },
  ordenacaoBusca: function ordenacaoBusca(state) {
    return state.ordenacaoBusca;
  },
  formBusca: function formBusca(state) {
    return state.formBusca;
  },
  unidades: function unidades(state) {
    return state.unidades;
  },
  modalidades: function modalidades(state) {
    return state.modalidades;
  },
  cursos: function cursos(state) {
    return state.cursos;
  },
  versoes: function versoes(state) {
    return state.versoes;
  },
  turmas: function turmas(state) {
    return state.turmas;
  },
  variaveisSimulacao: function variaveisSimulacao(state) {
    return state.variaveisSimulacao;
  },
  variaveisInformacoes: function variaveisInformacoes(state) {
    return state.variaveisInformacoes;
  },
  estudanteSimulacao: function estudanteSimulacao(state) {
    return state.estudanteSimulacao;
  },
  variaveisImportancia: function variaveisImportancia(state) {
    return state.variaveisImportancia;
  },
  formSimulacao: function formSimulacao(state) {
    return state.formSimulacao;
  },
  modelo: function modelo(state) {
    return state.modelo;
  }
});
// CONCATENATED MODULE: ./src/pages/estudantes/store/index.js





/* harmony default export */ var estudantes_store = ({
  namespaced: true,
  state: estudantes_store_state,
  actions: estudantes_store_actions,
  mutations: estudantes_store_mutations,
  getters: estudantes_store_getters
});
// CONCATENATED MODULE: ./src/store/modules.js
// Add modules HERE!!!




/* harmony default export */ var modules = ({
  auth: store,
  dashboard: dashboard_store,
  estudantes: estudantes_store
});
// CONCATENATED MODULE: ./src/store/index.js









vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var src_store = (new vuex_esm["a" /* default */].Store({
  state: store_state,
  getters: store_getters,
  actions: actions,
  mutations: mutations,
  modules: modules
}));
// CONCATENATED MODULE: ./src/router/beforeEach.js




var needAuth = function needAuth(auth) {
  return auth === true;
};
var authRouteName = 'auth.login';

var beforeEach_beforeEach = function beforeEach(to, from, next) {
  var auth = to.meta.requiresAuth;

  localforage_default.a.getItem(config["h" /* userIdStorageKey */]).then(function (userId) {

    if (userId) {
      gtag('config', config["e" /* googleGA */], {
        'user_id': userId
      });
      gtag('set', 'user_properties', {
        'id_usuario': userId
      });
    } else {
      gtag('config', config["e" /* googleGA */]);
    }
  });

  /**
   * Clears all global feedback message
   * that might be visible
   */
  src_store.dispatch('clearMessages');

  /**
   * If route doesn't require authentication be normally accessed.
   */
  if (!needAuth(auth)) {
    next();
    return; // return to prevent the code from continuing in its flow
    // With this flow `else` or `else if` is not necessary
  }

  /**
   * Otherwise  if authentication is required login.
   */
  src_store.dispatch('auth/checkUser').then(function () {
    // There is a token and it is valid
    next(); // can access the route
  }).catch(function (err) {
    // No token, or it is invalid
    next({
      name: authRouteName
    }); // redirect to login
  });
};

/* harmony default export */ var router_beforeEach = (beforeEach_beforeEach);
// CONCATENATED MODULE: ./src/router/afterEach.js


var DEFAULT_TITLE = 'Predição de Evasão - SESI/SENAI';

var afterEach_afterEach = function afterEach(to, from) {

  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  vue_esm["a" /* default */].nextTick(function () {
    if (to.meta.title) {
      document.title = DEFAULT_TITLE + ' - ' + to.meta.title;
    } else {
      document.title = DEFAULT_TITLE;
    }
  });
};

/* harmony default export */ var router_afterEach = (afterEach_afterEach);
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./src/pages/auth/routes/index.js
var Index = function Index(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sYF6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

/* harmony default export */ var routes = ([{
  name: 'auth.login',
  path: '/login',
  component: Index,
  meta: {
    title: 'Login'
  }
}]);
// CONCATENATED MODULE: ./src/pages/dashboard/routes/index.js
var Home = function Home(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JEu3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

/* harmony default export */ var dashboard_routes = ([{
  name: 'dashboard.home',
  path: '/',
  component: Home,
  meta: {
    requiresAuth: true,
    title: 'Início',
    menu: true,
    icon: 'fa fa-home'
  }
}]);
// CONCATENATED MODULE: ./src/pages/estudantes/routes/index.js
var routes_Index = function Index(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("niPP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Estudante = function Estudante(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KfCr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

/* harmony default export */ var estudantes_routes = ([{
  name: 'estudantes.lista',
  path: 'estudantes',
  component: routes_Index,
  meta: {
    requiresAuth: true,
    title: 'Busca Estudantes',
    menu: true,
    icon: 'fa fa-users'
  }
}, {
  name: 'estudantes.estudante',
  path: 'estudante/:id',
  component: Estudante,
  meta: {
    requiresAuth: true,
    title: 'Detalhes Estudante'
  }
}]);
// CONCATENATED MODULE: ./src/router/routes.js

/**
 * Add routes of each module
 */




var LayoutErro404 = function LayoutErro404(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("thLP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var LayoutDashboard = function LayoutDashboard(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TGvd")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var routes_routes = [].concat(toConsumableArray_default()(routes), [{
  name: 'dashboard',
  path: '/',
  component: LayoutDashboard,
  meta: {
    requiresAuth: true
  },
  children: [].concat(toConsumableArray_default()(dashboard_routes), toConsumableArray_default()(estudantes_routes))
}, {
  path: '*',
  component: LayoutErro404
}]);

/* harmony default export */ var router_routes = (routes_routes);
// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: router_routes
});

/**
* Before a route is resolved we check for
* the token if the route is marked as
* requireAuth.
*/
router.beforeEach(router_beforeEach);

router.afterEach(router_afterEach);

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/util/mixins.js
/* harmony default export */ var mixins = ({
  methods: {
    formataTextoMonetario: function formataTextoMonetario(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }
      var formato = {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL'
      };
      return valor.toLocaleString('pt-BR', formato);
    },
    formataTextoDecimalBrasil: function formataTextoDecimalBrasil(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }
      var formato = {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      };
      return valor.toLocaleString('pt-BR', formato);
    },
    formataTextoBoolean: function formataTextoBoolean(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }

      if (valor === false) {
        return "Não";
      }

      if (valor === true) {
        return "Sim";
      }
    },
    formataTextoString: function formataTextoString(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }
      return valor;
    },
    formataTextoInteger: function formataTextoInteger(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }
      return parseInt(valor);
    },
    formataTextoData: function formataTextoData(valor) {
      if (valor == undefined) {
        return 'Sem valor';
      }

      var date = new Date(valor);
      var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      };
      return date.toLocaleDateString('pt-BR', options);
    },
    formataTextoDataHora: function formataTextoDataHora(valor) {

      if (valor == undefined) {
        return 'Sem valor';
      }

      var date = new Date(valor);
      var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Sao_Paulo'
      };
      return date.toLocaleDateString('pt-BR', options);
    },
    stringIsDecimalValue: function stringIsDecimalValue(value) {
      return !!(value % 1);
    }
  }
});
// EXTERNAL MODULE: ./node_modules/vue-js-modal/dist/index.js
var dist = __webpack_require__("rifk");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/locale/pt_BR.js
var pt_BR = __webpack_require__("RAMx");
var pt_BR_default = /*#__PURE__*/__webpack_require__.n(pt_BR);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










vee_validate_esm["a" /* Validator */].localize('pt_BR', pt_BR_default.a);
vue_esm["a" /* default */].use(vee_validate_esm["b" /* default */]);

vue_esm["a" /* default */].use(http["a" /* default */], {
  store: src_store,
  router: src_router
});

vue_esm["a" /* default */].mixin(mixins);

vue_esm["a" /* default */].use(dist_default.a);

var moment = __webpack_require__("PJh5");
__webpack_require__("AoDM");

vue_esm["a" /* default */].use(__webpack_require__("mjDs"), {
  moment: moment
});

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  store: src_store,
  template: '<App/>',
  components: {
    App: src_App
  }
});

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiUrl; });
/* unused harmony export version */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return redirectUrlIDP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sgnUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return authorizeUrlIDP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clientHashIDP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return googleGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return userIdStorageKey; });
var apiUrl = "https://api-predicaoevasao.sc.senai.br/";
var version = Object({"NODE_ENV":"production","API_URL":"https://api-predicaoevasao.sc.senai.br/","TOKEN_STORAGE_KEY":"3xgpNnBfkH4KqFfy@","REDIRECT_URL_IDP":"https://predicaoevasao.sc.senai.br/login","AUTHORIZE_URL_IDP":"https://idp.fiesc.com.br/oauth2/authorize?response_type=code&scope=openid","CLIENT_HASH_IDP":"Dbqyd9Ag4a6PrhBBgupLnfkK57ca","GOOGLE_GA":"G-LBY0P5JW7Z","SGN_URL":"https://sgn.sesisenai.org.br/"}).VERSION;
var redirectUrlIDP = "https://predicaoevasao.sc.senai.br/login";
var sgnUrl = "https://sgn.sesisenai.org.br/";
var authorizeUrlIDP = "https://idp.fiesc.com.br/oauth2/authorize?response_type=code&scope=openid";
var clientHashIDP = "Dbqyd9Ag4a6PrhBBgupLnfkK57ca";
var appEnv = "production";
var googleGA = "G-LBY0P5JW7Z";
var userIdStorageKey = '_user_id';

/***/ }),

/***/ "SMGD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fhp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_http__ = __webpack_require__("7K8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_get__ = __webpack_require__("4ZlO");



var PREFIX_API = 'estudante';

var fetchEstudantes = function fetchEstudantes(params) {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].post(PREFIX_API + '/busca', params).then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

var fetchEstudante = function fetchEstudante(id_matricula) {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].get(PREFIX_API + '/' + id_matricula).then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

var fetchUnidades = function fetchUnidades() {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].get(PREFIX_API + '/filtro-busca/unidades').then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

var fetchModalidades = function fetchModalidades(params) {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].post(PREFIX_API + '/filtro-busca/modalidades', params).then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

var fetchCursos = function fetchCursos(params) {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].post(PREFIX_API + '/filtro-busca/cursos', params).then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

var fetchTurmas = function fetchTurmas(params) {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].post(PREFIX_API + '/filtro-busca/turmas', params).then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

var fetchVariaveisSimulacao = function fetchVariaveisSimulacao() {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].get(PREFIX_API + '/variaveis-simulacao').then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

var fetchVariaveisAbaInformacoes = function fetchVariaveisAbaInformacoes() {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].get(PREFIX_API + '/variaveis-informacoes').then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

var fetchVariaveisImportancia = function fetchVariaveisImportancia(id_matricula) {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].get(PREFIX_API + '/' + id_matricula + '/variaveis-importancia').then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

var fetchSimulacao = function fetchSimulacao(id_matricula, params) {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].post(PREFIX_API + '/' + id_matricula + '/simular-predicao', params).then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

var fetchPlotVariavel = function fetchPlotVariavel(id_matricula, params) {
  return __WEBPACK_IMPORTED_MODULE_0__plugins_http__["b" /* http */].get(PREFIX_API + '/' + id_matricula + '/plot-variavel', { params: params }).then(__WEBPACK_IMPORTED_MODULE_1__util_get__["a" /* getData */]);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchEstudantes: fetchEstudantes,
  fetchEstudante: fetchEstudante,
  fetchUnidades: fetchUnidades,
  fetchModalidades: fetchModalidades,
  fetchCursos: fetchCursos,
  fetchTurmas: fetchTurmas,
  fetchVariaveisSimulacao: fetchVariaveisSimulacao,
  fetchSimulacao: fetchSimulacao,
  fetchVariaveisImportancia: fetchVariaveisImportancia,
  fetchVariaveisAbaInformacoes: fetchVariaveisAbaInformacoes,
  fetchPlotVariavel: fetchPlotVariavel
});

/***/ }),

/***/ "p9lV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3b3G");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("549d8648", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/dist/cjs.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/dist/cjs.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9388e7e0241aacce444a.js